module.exports = __webpack_public_path__ + "img/de-product-classify_img_10.89c790fd.jpg";